import { z } from 'zod';
import { partnerEngagementSummarySchema } from './engagement.js';
import { leadStatusSchema } from './suitablePartners.js';
// Merged across every surface the lead is reachable from, so null means the partner never opened it at all.
export const offerRequestPartnerLeadOpeningSchema = z.object({
    firstOpeningDate: z.iso.datetime().nullable(),
    lastOpeningDate: z.iso.datetime().nullable(),
    openCount: z.number().int().nonnegative(),
});
// One partner's standing on one lead.
export const offerRequestPartnerLeadSchema = z.object({
    leadStatus: leadStatusSchema,
    shownInCockpitAt: z.iso.datetime(),
    opening: offerRequestPartnerLeadOpeningSchema,
    // Set only while the match is still running its clock; a match that was answered or has already timed
    // out has no remaining time to count down.
    expiresAt: z.iso.datetime().nullable(),
    // Null until the partner makes its first contact request.
    engagement: partnerEngagementSummarySchema.nullable(),
});
// Wrapped rather than returned bare, because Nest serializes a bare null as an empty body and the caller
// would receive an empty string instead of the absence it asked about.
export const offerRequestPartnerLeadResponseSchema = z.object({
    lead: offerRequestPartnerLeadSchema.nullable(),
});
